import { render, staticRenderFns } from "./SignupRedirectOpweb.vue?vue&type=template&id=635dd514&"
import script from "./SignupRedirectOpweb.vue?vue&type=script&lang=ts&"
export * from "./SignupRedirectOpweb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports